var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEraser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eraser_disabled",
    "data-name": "eraser disabled",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 46,
    viewBox: "0 0 35 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_122",
    "data-name": "Rectangle 122",
    width: 35,
    height: 46,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M.446,57.06a7.313,7.313,0,0,0-.323,1.407c-.175,1.057-.228,6,.27,7.452a6.722,6.722,0,0,0,2.253,2.662l10.868,6.444h0l.012.006,0,0a3.3,3.3,0,0,0,2.53.507,3.252,3.252,0,0,0,2.294-1.407l16.161-25.6a3.572,3.572,0,0,0,.432-2.607c-.139-.983-1.032-7.1-1.032-7.1Z",
    transform: "translate(0 -29.63)",
    fill: "#c34135"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M13.516,126.142l.012.006,0,0a3.522,3.522,0,0,0,1.961.59l-1.824-14.517a27.65,27.65,0,0,0-8.887-6.409l-4.333,2.36a7.313,7.313,0,0,0-.323,1.407c-.175,1.057-.228,6,.27,7.452A6.722,6.722,0,0,0,2.647,119.7l10.868,6.444Z",
    transform: "translate(0 -80.745)",
    fill: "#d4544d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M33.419,6.49a3.247,3.247,0,0,1,1.309,4.538L18.436,36.022a3.607,3.607,0,0,1-4.85.9L3.549,30.983a3.249,3.249,0,0,1-1.307-4.538L18.533,1.451a3.608,3.608,0,0,1,4.85-.9Z",
    transform: "translate(-1.35 0)",
    fill: "#ec7063"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M111.58,47.883A3.571,3.571,0,0,0,112,45.251c-.147-.994-1.094-7.178-1.094-7.178l-9.673,5.2c-.557,3.988-.4,7.465,1.023,9.64l1.826,6.978Z",
    transform: "translate(-77.022 -29.053)",
    fill: "#7dae9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M54.2,23.658l.951-1.357L62.5,11.028A3.248,3.248,0,0,0,61.194,6.49L51.157.554a3.607,3.607,0,0,0-4.85.9l-8.14,12.487Z",
    transform: "translate(-29.125 0)",
    fill: "#92cebd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraser);
export default __webpack_public_path__ + "static/media/eraser.b2cf93df6cda6ac0c2e2ce60924a67a6.svg";
export { ForwardRef as ReactComponent };